'use client'
import { LayoutModal } from 'design-system/client'
import { usePathname, useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { type ReactNode, useCallback } from 'react'
import { Routes } from '@/helpers/utils'
import type { Locale } from '@/i18n/types'

function ModalShell({ children, locale, slug }: { children: ReactNode; locale: Locale; slug: string }) {
  const t = useTranslations('nextjs')
  const router = useRouter()
  const onClose = useCallback(() => {
    router.push(Routes.fundraisingEvents({ locale, slug }, true))
  }, [locale, router, slug])

  // navigating back with router.push with parallel routing does not close the modal
  const pathname = usePathname()

  return (
    <LayoutModal
      isOpen={pathname.includes('sharing-options')}
      title={t('core.share_fundraising_event')}
      onClose={onClose}
      closeText={t('core.close')}
      hideActions
      closeOnClickOutside
    >
      {children}
    </LayoutModal>
  )
}
export default ModalShell
